import React, { FunctionComponent } from 'react'
import { ThreatMatrixProps } from './types'

export const ThreatMatrix: FunctionComponent<ThreatMatrixProps> = ({ profilingSessionId, tmOrganisationId, children }) => {
  return Boolean(profilingSessionId) && Boolean(tmOrganisationId) ? (
    <>
      <iframe data-testid='threat-matrix-iframe' hidden src={`https://rsx.afterpay.com/fp/tags?org_id=${tmOrganisationId}&session_id=${profilingSessionId}`} />
      {children}
    </>
  ) : null
}
